(() => {
  const init = () => {
    const root = document.querySelector('#KsGearBuy-knr-011,#KsGearBuy-knr-012');
    if (!root) return;
    if (document.documentElement.classList.contains('ks-series-hero-preview')) {
      const templates = [...document.querySelectorAll('template[data-se-variant]')];
      templates.forEach(template => {
        const button = root.querySelector('[data-ks-variant="' + template.dataset.seVariant + '"]');
        if (button && !button.querySelector('.mh-model-image')) button.prepend(template.content.cloneNode(true));
      });
      const refreshModelImages = () => {
        const quantity = root.querySelector('[data-ks-axis="0"] [aria-pressed="true"]')?.dataset.ksChoice;
        root.querySelectorAll('[data-ks-axis="1"] .ks-choice').forEach(button => {
          const template = templates.find(t => { const options = JSON.parse(t.dataset.seOptions); return options[0] === quantity && options[1] === button.dataset.ksChoice; });
          if (!template || button.dataset.seImageVariant === template.dataset.seVariant) return;
          button.querySelector('.mh-model-image')?.remove();
          button.prepend(template.content.cloneNode(true));
          button.dataset.seImageVariant = template.dataset.seVariant;
        });
      };
      refreshModelImages();
      root.addEventListener('click',event => { if (event.target.closest('.ks-choice')) requestAnimationFrame(refreshModelImages); });
      const plate = '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/>';
      const swing = '<path d="M5 12a7 7 0 1 0 2-5M5 3v5h5"/><path d="m12 8 3 4-3 4"/>';
      const grip = '<path d="M5 6v12M19 6v12M8 4v16M16 4v16M8 12h8"/>';
      const lock = '<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>';
      const paths = root.id.endsWith('011') ? [swing,plate,grip] : [plate,swing,lock];
      root.querySelectorAll('.ks-pdp-benefits svg').forEach((icon,index) => { if(paths[index]) icon.innerHTML = paths[index]; });
      root.querySelectorAll('a.ks-assurance-item').forEach(a => { const div=document.createElement('div'); div.className=a.className; while(a.firstChild)div.append(a.firstChild);a.replaceWith(div); });
    }
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.add('se-visible');observer.unobserve(entry.target);}}),{threshold:.15});
      document.querySelectorAll('.se-story .ecla-shelf,.se-story .clace-mech__main,.se-story .ecla-vs__grid').forEach(el=>observer.observe(el));
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
